import { render } from "./my-shifts.vue?vue&type=template&id=4786fc12&scoped=true"
import script from "./my-shifts.vue?vue&type=script&lang=js"
export * from "./my-shifts.vue?vue&type=script&lang=js"

import "./my-shifts.vue?vue&type=style&index=0&id=4786fc12&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4786fc12"]])

export default __exports__